import {
    Home,
    UserWorker,
    List,
    Location,
    Currency,
    Send, Ticket
} from "grommet-icons";
import HomePage from "./Home.js";
import Anagrafiche2 from "./components/registryComponent/Anagrafiche2.js";
import MapLocation from "./components/mapLocation/MapLocation.js";
import UserClubMateEventList from "./components/UserEvents/UserEventList.js";
import SendNotification from "./components/notification/SendNotification.js";
import EntranceList from "./components/entrance/EntranceList.js";
import MovementList from "./components/payments/Payments.js";

const routes=[
     {
        role:["admin","Admin_Cantiere","Admin_Zona"],
        name:"Home",
        pageName:"Home",
        icon: Home,
         visibleOnCardMenu:false,
         homeComponent:HomePage
    },
    {
        role:["admin","Admin_Cantiere","Admin_Zona"],
        name:"Anagrafiche",
        pageName:"Anagrafiche",
        icon: UserWorker,
        visibleOnCardMenu:true,
        homeComponent:Anagrafiche2
    },
    {
        role:["admin","Admin_Cantiere","Admin_Zona"],
        name:"Elenco Ingressi",
        pageName:"Entrance",
        icon:Ticket,
        visibleOnCardMenu:true,
        homeComponent:EntranceList
    },
    {
        role:["admin","Admin_Cantiere","Admin_Zona"],
        name:"Servizi utilizzati",
        pageName:"ServiziUtilizzati",
        icon: List,
        visibleOnCardMenu:true,
        homeComponent:UserClubMateEventList
    },
    {
        role:["admin","Admin_Cantiere","Admin_Zona"],
        name:"Movimenti",
        pageName:"Movimenti",
        icon: Currency,
        visibleOnCardMenu:true,
        homeComponent: MovementList
    },
    {
        role:["admin","Admin_Cantiere","Admin_Zona"],
        name:"Mappa",
        pageName:"Mappa",
        icon: Location,
        visibleOnCardMenu:true,
        homeComponent:MapLocation
    },
    {
        role:["admin","Admin_Cantiere","Admin_Zona"],
        name:"Invia notifiche",
        pageName:"SendNotification",
        icon:Send,
        visibleOnCardMenu:true,
        homeComponent:SendNotification
    }
]

export {routes};